'use client';

import { useRefWithInit } from '@base-ui/utils/useRefWithInit';
function initializeInputApiRef(publicAPI, apiRef) {
  if (apiRef != null && apiRef.current == null) {
    apiRef.current = publicAPI;
  }
}
export function useInitializeApiRef(store, apiRef) {
  const publicAPI = useRefWithInit(() => store.buildPublicAPI()).current;
  initializeInputApiRef(publicAPI, apiRef);
}